export enum CardType {
  VISA = 'VISA',
  MASTERCARD = 'MASTERCARD',
  AMEX = 'AMEX',
  UNKNOWN = 'UNKNOWN',
}



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/client/src/model/card-type.ts